import React from 'react';
import T from 'prop-types';
import { map } from 'lodash-es';

import SimpleDropdown from '../../../components/Dropdowns/SimpleDropdown';

const MetricList = ({
  selected,
  options,
  disabled,
  menuWidth = 220,
  appendButtonText,
  className,
  onChange,
}) => {
  const decoratedOptions = appendButtonText
    ? options.map((option) => ({
        ...option,
        buttonLabel: (
          <>
            <span>{option.label}</span>
            <span className="label-caption">{appendButtonText}</span>
          </>
        ),
      }))
    : options;

  return (
    <div className={`metric-list-dropdown ${className || ''}`}>
      <SimpleDropdown
        selected={selected}
        options={decoratedOptions}
        caret
        frameless
        disabled={disabled}
        menuWidth={menuWidth}
        isActiveSelectable={false}
        onChange={onChange}
      />
    </div>
  );
};

const basePropTypes = {
  selected: T.string.isRequired,
  disabled: T.bool,
  onChange: T.func.isRequired,
};

MetricList.propTypes = {
  ...basePropTypes,
  appendButtonText: T.string,
  options: T.arrayOf(
    T.shape({
      label: T.string,
      value: T.string,
      disabled: T.bool,
    })
  ).isRequired,
};

const metricsToOptions = (metrics) =>
  map(metrics, (label, value) => ({
    label,
    value,
    className: 'menu-item--14',
  }));

// ActivityMetricDropdown
export const activityMetrics = {
  dau: 'DAU',
  downloads: 'Downloads',
};

export const ActivityMetricDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={metricsToOptions(activityMetrics)}
    menuWidth={118}
    onChange={onChange}
  />
);

ActivityMetricDropdown.propTypes = basePropTypes;

export const marketShareMetrics = {
  dau: 'Market Share — DAU',
  downloads: 'Market Share — Downloads',
};

export const MarketShareDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={metricsToOptions(marketShareMetrics)}
    menuWidth={220}
    onChange={onChange}
  />
);

MarketShareDropdown.propTypes = basePropTypes;

export const segmentConcentrationMetrics = {
  high_frequency_ai_users: 'Segment Concentration — High-Frequency Users',
  medium_frequency_ai_users: 'Segment Concentration — Medium-Frequency Users',
};

export const SegmentConcentrationDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={metricsToOptions(segmentConcentrationMetrics)}
    menuWidth={385}
    className="header-dropdown"
    onChange={onChange}
  />
);

SegmentConcentrationDropdown.propTypes = basePropTypes;

export const timeSpentMetrics = {
  high_frequency_ai_users: 'Time Spent — High-Frequency AI Users',
  medium_frequency_ai_users: 'Time Spent — Medium-Frequency AI Users',
};

export const TimeSpentDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={metricsToOptions(timeSpentMetrics)}
    menuWidth={345}
    onChange={onChange}
  />
);

TimeSpentDropdown.propTypes = basePropTypes;

export const appImpactMetrics = {
  average_time_spent_per_dau: 'Avg Time Spent per DAU',
  average_sessions_per_dau: 'Average sessions per DAU',
};

export const AppImpactDropdown = ({ selected, disabled, onChange }) => (
  <MetricList
    selected={selected}
    disabled={disabled}
    options={metricsToOptions(appImpactMetrics)}
    menuWidth={220}
    className="header-dropdown"
    onChange={onChange}
  />
);

AppImpactDropdown.propTypes = basePropTypes;
